import styled from 'styled-components'

export const CustomTable = styled.table`
    position: relative;
    width: calc(100% - 15px);

    .export-pdf {
        &.fa .fas {
            display: none;
        }
    }

    &,
    td,
    th {
        border-bottom: 1px solid var(--gray-400);
        text-align: left;
        padding: 8px;
        height: calc(595.3px / 8);
        line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 1.5px;
    }

    thead tr th {
        color: var(--gray-700);
        font-family: var(--font-bold);
        font-size: 12px;
        white-space: nowrap;
    }

    /* tbody  */

    tbody {
        tr {
            td {
                color: var(--gray-800);
            }

            .custom-list-column-actions {
                white-space: nowrap;
                opacity: 0;
                text-align: right;
            }

            &:hover {
                background-color: var(--blue-200);

                .custom-list-column-actions {
                    opacity: 1;
                }
            }
        }

        i {
            color: var(--blue-500);
            font-size: 16px;
            cursor: pointer;

            &:not(:last-child) {
                margin-right: 6px;
            }

            &.fa-trash {
                color: var(--red-700);
            }

            &.fa-trash-alt {
                color: var(--red-700);
            }
        }
    }
`
